import { format } from "date-fns";
import * as XLSX from "xlsx";


export interface DownloadFileModel {
  fileName: string;
  contentType: string;
  data: string;
}

export function downloadCsv(file: DownloadFileModel) {
  if (!file) return;

  let data = new Blob([file.data], { type: file.contentType });
  let urlFile = window.URL.createObjectURL(data);
  let link = document.createElement("a");
  document.body.appendChild(link);
  link.style.display = "none";
  link.href = urlFile;
  link.download = file.fileName ?? "Data.csv";
  link.click();
  window.URL.revokeObjectURL(urlFile);
}

export function downloadXlsx(file: Blob, fileName: string) {
  if (!file) return;

  const blob = new Blob([file]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
}

 // Function to convert an array of objects to CSV string
 export const convertArrayToCSV = (array: any[]) => {
  const header = Object.keys(array[0]).join(',');
  const rows = array.map(obj => Object.values(obj).join(',')).join('\n');
  return `${header}\n${rows}`;
};


export const prepareAndDownloadFile = (fileData: any[], fileName:string) => {
  // making each key first letter as upper case
  const dataForFile = fileData.map((obj: any) => {
    const newObj: any = {};
    for (const key in obj) {
      newObj[key.charAt(0).toUpperCase() + key.slice(1)] = obj[key];
    }
    return newObj;
  });
  const worksheet = XLSX.utils.json_to_sheet(dataForFile);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet);
  XLSX.writeFile(
    workbook,
     fileName + format(new Date(), "yyyyMMddHHmmss") + ".xlsx",
    {
      compression: true,
    }
  );
};
